import { render, staticRenderFns } from "./CourtCasesList.vue?vue&type=template&id=b353a9d0&"
import script from "./CourtCasesList.vue?vue&type=script&lang=js&"
export * from "./CourtCasesList.vue?vue&type=script&lang=js&"
import style0 from "./CourtCasesList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports